const currencyOptions = [
    "USD", "GBP", "CHY", "YEN", "EUR"
];

export default currencyOptions;